import React, {Component} from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import styles from '../Calculator.scss';
import classnames from "classnames";

export default class BottomButtons extends Component {

  constructor(props) {
    super(props);
    this.state = { }
  }

  render() {
    return(
      <div className={styles.center}>
        <button className={classnames("btn btn-secondary", styles.CompareDifferent)}
          onClick={this.props.deselectCity}>
          <FontAwesomeIcon
            icon={faArrowLeft}
          />
          {" Compare A Different City!"}
        </button>
        {/*<span style={{float: "right"}}>
        <EmailModal
          buttonText={'Click Here For Promo Codes!'}
          title={'Enter your email to receive Promo Codes'}
        />
        </span>*/}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Calculator/sections/BottomButtons.js